import { z } from '@harvestiq/zod';
import { evergreenSigningAgentSchema } from './evergreen-signing-agent';
import { DbOrderDirection } from '@harvestiq/constants';
import { dbEvergreenSigningAgentSchema } from './db-evergreen-signing-agent';

export const getEvergreenSigningAgentsRequestQuerySchema = z.object({
  ids: z.array(z.string().uuid()).optional(),
  searchText: z.string().optional(),
  orderBy: z
    .string()
    .refine(
      (value: string) =>
        Object.keys(dbEvergreenSigningAgentSchema.shape).includes(value),
      {
        message: 'Invalid orderBy field',
      }
    )
    .default('createdAt')
    .optional(),
  orderDirection: z
    .nativeEnum(DbOrderDirection)
    .default(DbOrderDirection.DESC)
    .optional(),
});
export type GetEvergreenSigningAgentsRequestQuery = z.infer<
  typeof getEvergreenSigningAgentsRequestQuerySchema
>;

export const getEvergreenSigningAgentsResponseSchema = z.object({
  data: evergreenSigningAgentSchema.array(),
});
export type GetEvergreenSigningAgentsResponse = z.infer<
  typeof getEvergreenSigningAgentsResponseSchema
>;
